import { useState } from 'react';

// localStorage-backed state hook.
// Note: on React Native, swap localStorage for AsyncStorage (same interface).
export function usePersist(key, defaultVal) {
  const [val, setVal] = useState(() => {
    try {
      const s = localStorage.getItem(key);
      return s !== null ? JSON.parse(s) : defaultVal;
    } catch { return defaultVal; }
  });

  const set = (next) => {
    setVal((prev) => {
      const resolved = typeof next === 'function' ? next(prev) : next;
      try { localStorage.setItem(key, JSON.stringify(resolved)); } catch (e) {
        console.warn('HydroCalc: localStorage write failed', e);
      }
      return resolved;
    });
  };

  return [val, set];
}
